import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import FilterPill from '../filterpill/FilterPill';
import filterDefinitionPropType from '../../../filterDefinitionPropType';

const renderSingleValue = (value, availableValues, includeGroupTitle = true) => {
    const hasChildren = fp.filter((av) => av.children)(availableValues);
    const children = fp.flatten(hasChildren.map((parent) => parent.children.map((child) => fp.set('parent', parent.title)(child))));
    const index = fp.findIndex((child) => child.value === value)(children);
    if (index !== -1) {
        return includeGroupTitle
            ? `${children[index].parent} - ${children[index].title}`
            : `${children[index].title}`;
    }
    const noChildren = fp.filter((av) => !av.children)(availableValues);
    const indexNoChildren = fp.findIndex((child) => child.value === value)(noChildren);
    if (indexNoChildren !== -1) {
        return noChildren[indexNoChildren].title;
    }
    return '';
};

const renderValue = (value, availableValues, filterDefinition) => {
    // modify this to cope with name value pairs too
    if (value.length === 0) {
        if (filterDefinition && filterDefinition.customEmptyValue) {
            return filterDefinition.customEmptyValue;
        }
        return filterDefinition && filterDefinition.radio ? 'None' : 'All';
    }

    let title;
    const includeGroupTitle = fp.get('includeGroupTitle')(filterDefinition);
    if (availableValues.length) {
        if (value.length < 4) {
            title = value.map((v) => renderSingleValue(v, availableValues, includeGroupTitle)).join(', ');
        } else {
            title = (
                <span>
                    { value.slice(0, 3).map((v) => renderSingleValue(v, availableValues, includeGroupTitle)).join(', ') }
                    <span style={ {
                        fontWeight: 'normal'
                    } }
                    > +{ value.length - 3 } more
                    </span>
                </span>
            );
        }
    } else {
        title = '...';
    }

    return title;
};

class ListFilterPill extends Component {
    componentDidMount() {
        if (this.props.filter.value.length) {
            this.props.getAvailableListValues();
        }
    }

    render() {
        return (
            <FilterPill
                fixed={ this.props.fixed }
                disabled={ this.props.disabled }
                filter={ this.props.filter }
                filterError={ this.props.filterError }
                displayValue={ renderValue(this.props.filter.value,
                    this.props.filterDefinition && this.props.filterDefinition.availableValues
                        ? this.props.filterDefinition.availableValues : [], this.props.filterDefinition) }
                isOpen={ this.props.isOpen }
                openFilter={ this.props.openFilter }
                removeFilter={ this.props.removeFilter }
                updateFilter={ this.props.updateFilter }
                getAvailableListValues={ this.props.getAvailableListValues }
                filterDefinition={ this.props.filterDefinition }
            />
        );
    }
}

ListFilterPill.propTypes = {
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.arrayOf(PropTypes.string)
    }).isRequired,
    filterError: PropTypes.shape({}),
    isOpen: PropTypes.bool,
    openFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    getAvailableListValues: PropTypes.func.isRequired,
    filterDefinition: filterDefinitionPropType
};

ListFilterPill.defaultProps = {
    fixed: false,
    isOpen: false,
    filterError: null,
    disabled: false,
    filterDefinition: null
};

export default ListFilterPill;
